import { Notifier } from '@airbrake/browser';

let notifier = null;

export function initAirbrake(app) {
  if (process.env.NODE_ENV === 'production') {
    notifier = new Notifier({
      environment: 'production',
      projectId: process.env.VUE_APP_AIRBRAKE_PRODUCT_ID,
      projectKey: process.env.VUE_APP_AIRBRAKE_PRODUCT_KEY,
    });
    app.config.errorHandler = function (err, vm, info) {
      notifier.notify({ error: err, params: { info } });
    };
  }
}

export function notifyAirbrake(error, params = {}) {
  if (notifier) {
    notifier.notify({ error, params });
  }
}
